import React from "react"
import { ModalSeeker } from "@ui-seeker/core"
import { isOpenInfoModal } from "Pages/ReportsAlerts/Reports/@signals"
import ReportInfoModalContent from "Pages/ReportsAlerts/Reports/@components/InfoModal/Content"


export default function ReportInfoModal() {


	return <ModalSeeker
		containerProps={{
			maxWidth: "lg",
			height: "70%",
			p: 2
		}}
		isOpen={!!isOpenInfoModal.value}
		controller={() => isOpenInfoModal.value = null}
		hideActions
	>
		<ReportInfoModalContent/>
	</ModalSeeker>
}